/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './flow';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "DebitCardManagement": {
                    "nested": {
                      "ClientCapableFlow": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "BB_FRONTEND_FLOW": 1,
                          "ORDERING": 2,
                          "ACTIVATION": 3,
                          "DIGITAL_WALLET": 4,
                          "BILLING_ADDRESS": 5,
                          "RESET_PIN": 6,
                          "NOTIFICATION_PREFERENCES": 7,
                          "HELP": 8,
                          "PRIVATE_CARD_DATA_2FA": 9,
                          "ATM_LIMITS": 10,
                          "DEACTIVATE_ADDITIONAL_CARD": 11
                        }
                      },
                      "ClientHandleableFlow": {
                        "fields": {
                          "clientCapableFlow": {
                            "type": ".squareup.bbfrontend.service.v1.DebitCardManagement.ClientCapableFlow",
                            "id": 1,
                            "rule": "optional"
                          },
                          "flow": {
                            "type": ".squareup.bbfrontend.service.v1.Flow",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "DebitCardManagementFlow": {
                    "fields": {
                      "cardToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardManagement?.nested?.ClientCapableFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardManagement?.nested?.ClientHandleableFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardManagementFlow) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DebitCardManagement @ squareup/bbfrontend/v1/debit_card_management.proto at 12:1
 */
export const DebitCardManagement = {};
/**
 * Flows that have native client implementations and that the clients know how to handle.
 * These will be supplied in the request by the client when requesting
 * the management configuration.
 *
 * SOURCE ClientCapableFlow @ squareup/bbfrontend/v1/debit_card_management.proto at 18:3
 */
DebitCardManagement.ClientCapableFlow = $root.lookupEnum('squareup.bbfrontend.service.v1.DebitCardManagement.ClientCapableFlow').values;
/**
 * Used in order to maintain backward compatibility with flows that are purely client driven.
 *
 * SOURCE ClientHandleableFlow @ squareup/bbfrontend/v1/debit_card_management.proto at 36:3
 */
DebitCardManagement.ClientHandleableFlow = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardManagement.ClientHandleableFlow');
fixType(DebitCardManagement.ClientHandleableFlow, {
  clientCapableFlow: {
    required: true
  }
});
Builder.createAndAttachToType(DebitCardManagement.ClientHandleableFlow);
/**
 * SOURCE DebitCardManagementFlow @ squareup/bbfrontend/v1/debit_card_management.proto at 51:1
 */
export const DebitCardManagementFlow = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardManagementFlow');
fixType(DebitCardManagementFlow, {
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DebitCardManagementFlow);